import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";

import iconcontentcalendar from "../../../../../Images/Icons/iconcontentcalendar.png";
import { GlobalContext } from "../../../../../Contexts/GlobalContextProvider";

const DateInput = ({ control, errors }) => {
   const { t: translator } = useTranslation();
   const { selectedLanguageId } = useContext(GlobalContext);

   return (
      <div className="form-group">
         <label>{translator("InitialState-Date")}</label>
         <div className="input-group">
            <div className="input-group-prepend">
               <span className="input-group-text" id="basic-addon1">
                  <img src={iconcontentcalendar} alt="calendar" />
               </span>
            </div>
            <Controller
               as={DatePicker}
               control={control}
               autoComplete="off"
               className="form-control"
               dateFormat="dd.MM.yyyy"
               name="date"
               showYearDropdown={true}
               rules={{ required: true }}
               locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
               valueName="selected"
               defaultValue={new Date()}
               onChange={([selected]) => selected}
               minDate={new Date()}
            />
            {errors.date && errors.date.type === "required" && (
               <p className="col-md-10 pl-0 text-danger">
                  {translator("ValidationMsg-RequiredField")}
               </p>
            )}
         </div>
      </div>
   );
};

export default DateInput;
